import { Component, OnInit, HostListener } from '@angular/core';
import { ObservatoryService, StorageService, UserService } from '@services/services.module';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ROL_TYPE } from '@app/constants/enums';

@Component({
  selector: 'app-gestion-empleados',
  templateUrl: './gestion-empleados.component.html',
  styleUrls: ['./gestion-empleados.component.scss']
})
export class GestionEmpleadosComponent implements OnInit {

  public isAdmin: boolean;
  public textHeader = '';

  @HostListener('window:beforeunload') goToPage() {
    this.storage.set('reload', true);
  }

  constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private storage: StorageService,
    private observatory: ObservatoryService,
    private router: Router,
    private _user: UserService
  ) {
    window.scrollTo(0, 0);
    // forzar eliminar el ultimo elemento buscado en el buscador
    this.observatory.setData('idItemList', '');
  }

  ngOnInit() {
    this.translate.get(this.activatedRoute.snapshot.data['title']).subscribe((res: string) => {
      this.titleService.setTitle(res);
    });
    // Control de usuarios para bloquear la navegacion por url
    this.urlUserControl();
    this.observatory.getData('textHeader').subscribe(val => {
     if (val === 'new' || val === '') {
      this.textHeader = this.translate.instant('NEMP');
     } else {
      this.textHeader = this.translate.instant('MODNP');
     }
    });
  }

  routeTo(route) {
    this.router.navigate([route]);
  }

  urlUserControl(): void {
    this._user.checkRolType([ROL_TYPE.admin, ROL_TYPE.direction, ROL_TYPE.operations]).then((data: any) => {
      this.isAdmin = data.value;
      if (!this.isAdmin) {
        this.router.navigate(['home']);
      }
    });
  }

}
